<app-header [nav]="nav" />
<mat-tab-group (selectedIndexChange)="changeTab($event)">
  <mat-tab label="Recommendations">
    <app-recommendation-table
      [all]="false"
      *matTabContent />
  </mat-tab>
  <mat-tab label="Audit">
    <app-audit-table
      [all]="false"
      *matTabContent />
  </mat-tab>

  <mat-tab label="Recommendations ALL">
    <app-recommendation-table
      [all]="true"
      *matTabContent />
  </mat-tab>
  <mat-tab label="Audit ALL">
    <app-audit-table
      [all]="true"
      *matTabContent />
  </mat-tab>
</mat-tab-group>
